/** @format */
import {ChangeEvent} from 'react';

import {AsYouType} from 'libphonenumber-js';
import {useTranslation} from 'react-i18next';

import type {TextFieldProps} from '@mui/material/TextField';

import LegacyTextField from 'components/inputs/LegacyTextField';

type Props = {
  value?: string;
  onChangePhone: (value: string) => void;
} & TextFieldProps;

const PhoneNumberField = ({value, onChangePhone, placeholder, ...attrs}: Props) => {
  const {t} = useTranslation();
  const formattedValue = new AsYouType().input(value || '');

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const {value} = event.target;
    const formattedValue = new AsYouType().input(value);
    onChangePhone(formattedValue);
  };

  return (
    <LegacyTextField
      value={formattedValue}
      placeholder={placeholder ? placeholder : t('Номер телефона', 'Номер телефона')}
      type='tel'
      myProps={{
        placeholderFocused: t('Например, +7 995 880 40 320', 'Например, +7 995 880 40 320'),
      }}
      onChange={handleChange}
      {...attrs}
    />
  );
};

export default PhoneNumberField;
